import precognitive from 'laravel-precognition';
import { computed, isReactive, reactive, ref } from 'vue';
import { patchInertiaForm } from './inertia';
import { patchVueForm } from './vue';
export const usePrecognitiveForm = (method, url, data = {}, config) => {
    /**
     * Check if the for is an Inertia form.
     */
    const isInertiaForm = isReactive(data);
    /**
     * Base validator.
     */
    const validator = precognitive.validate(client => {
        const m = method.toLowerCase();
        return m === 'get' || m === 'delete' ? client[m](url, config) : client[m](url, form.data(), config);
    });
    /**
     * Reactive validating state.
     */
    const validating = ref(validator.validating());
    validator.on('validatingChanged', () => validating.value = validator.validating());
    /**
     * Reactive processing validation state.
     */
    const processingValidation = ref(validator.processingValidation());
    validator.on('processingValidationChanged', () => processingValidation.value = validator.processingValidation());
    /**
     * Reactive touched inputs state.
     */
    const touched = ref(validator.touched());
    validator.on('touchedChanged', () => touched.value = validator.touched());
    /**
     * Reactive passed validation state.
     */
    const passed = computed(() => touched.value.filter((name) => typeof form.errors[name] === 'undefined'));
    /**
     * The form instance...
     */
    let form = isReactive(data) ? data : reactive(data);
    const patchForm = isInertiaForm
        ? patchInertiaForm
        : patchVueForm;
    form = patchForm(method, url, form, validator);
    return Object.assign(form, {
        validate(input) {
            validator.validate(input);
            return this;
        },
        validating,
        processingValidation,
        passed,
        touched,
        setValidationTimeout(timeout) {
            validator.setTimeout(timeout);
            return this;
        },
    });
};
export { precognitive as default };
